import {
  keepPreviousData,
  QueryClient,
  useMutation,
  useQuery,
  useQueryClient
} from "@tanstack/react-query";
import { syndicationFeedApi, SyndicationFeed } from "api/syndicationFeed";
import { ApartmentsComVariant, ZillowVariant } from "types/landlord/address";

const SYNDICATION_FEED_KEY = "SYNDICATION_FEED";

const DEFAULT_PER_PAGE = Number(window.localStorage.getItem("per_page")) || 10;

export const feedListingsQueryKey = (feed: SyndicationFeed) => [
  SYNDICATION_FEED_KEY,
  feed,
  "LISTINGS"
];

export const invalidateFeedQueries = (
  queryClient: QueryClient,
  feed: SyndicationFeed
) => {
  queryClient.invalidateQueries({ queryKey: feedListingsQueryKey(feed) });
  queryClient.invalidateQueries({ queryKey: ["unit"] });
  queryClient.invalidateQueries({ queryKey: ["properties"] });
};

export const useFeedListings = (feed: SyndicationFeed, page: number) =>
  useQuery({
    queryKey: [...feedListingsQueryKey(feed), page],
    queryFn: () =>
      syndicationFeedApi.getFeedListings(feed, {
        page,
        per_page: DEFAULT_PER_PAGE
      }),
    placeholderData: keepPreviousData
  });

interface ToggleFeedListingVariables {
  unitId: number;
  enabled?: boolean;
  variant?: ApartmentsComVariant | ZillowVariant;
  spotlight_enabled?: boolean;
  featured_enabled?: boolean;
}

export const useToggleFeedListing = (feed: SyndicationFeed) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [...feedListingsQueryKey(feed), "UPDATE"],
    mutationFn: ({
      unitId,
      enabled,
      variant,
      spotlight_enabled,
      featured_enabled
    }: ToggleFeedListingVariables) =>
      syndicationFeedApi.toggleFeedListing(feed, unitId, {
        enabled,
        variant,
        spotlight_enabled,
        featured_enabled
      }),
    onSuccess: () => invalidateFeedQueries(queryClient, feed)
  });
};
